module.exports = __webpack_public_path__ + "img/organize-staff.39f266e1.svg";